import { trigger, transition, style, animate, state } from '@angular/animations';

// export function notificationAnimations() {
//   return [
//     trigger(
//       'inOutAnimation',
//       [
//         transition(
//           ':enter',
//           [
//             style({
//               opacity: 0,
//               transform: 'translate3d(-12px, 0, 0)',
//             }),
//             animate(
//               '150ms ease-in',
//               style({
//                 transform: 'translate3d(0, 0, 0)',
//                 opacity: 1
//               })
//             )
//           ]
//         ),
//         transition(
//           ':leave',
//           [
//             style({
//               height: '*',
//               opacity: 1,
//               overflow: 'hidden'
//             }),
//             sequence([
//               animate(
//                 '100ms ease-out',
//                 style({
//                   opacity: 0,
//                   transform: 'translate3d(0, 6px, 0)'
//                 })
//               ),
//               animate(
//                 '250ms ease-out',
//                 style({
//                   height: 0,
//                   margin: 0
//                 })
//               )
//             ])
//           ]
//         )
//       ]
//     )
//   ];
// }

export function notificationAnimations() {
  return [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translate3d(0, -12px, 0)',
        }),
        animate(150, style({
          transform: 'translate3d(0, 0, 0)',
          opacity: 1
        }))
      ]),
      transition(':leave', [
        style({
          height: '*',
          opacity: 1,
          // overflow: 'hidden'
        }),
        animate(200, style({
          opacity: 0,
          transform: 'translate3d(0, 4px, 0)'
        }))
      ])
    ]),

    trigger('showHide', [
      state('hidden', style({
        opacity: 0,
        height: 0,
        overflow: 'hidden'
      })),
      // Define the 'visible' state
      state('visible', style({
        opacity: 1,
        height: 'auto', // 'auto' height animation
        overflow: 'hidden'
      })),
      // Define the transition from hidden to visible
      transition('hidden => visible', [
        animate('300ms ease-in') // Animation duration and easing
      ]),
      // Define the transition from visible to hidden
      transition('visible => hidden', [
        animate('300ms ease-out') // Animation duration and easing
      ])
    ])
  ];
}

